module.exports = __webpack_public_path__ + "img/free-access-books.d646ac70.svg";